import { SvgIcon, useTheme } from '@mui/material'

import { Alerts } from 'features/alerts/components/Alerts'
import { AlertData } from 'features/alerts/components/Alerts/types'
import { Alert } from 'features/alerts/types/alert'
import { DomainPrebidModule } from 'features/inventory/domain/types/domainPrebidModule'
import { DomainPrebidModuleAlert } from 'features/inventory/domain/types/domainPrebidModuleAlert'
import UnpluggedIcon from 'images/icons/unplugged.svg?react'

type Props = {
  alerts: DomainPrebidModule['alerts']
}

export const DomainPrebidModuleAlerts = ({ alerts }: Props): React.JSX.Element => {
  const theme = useTheme()

  const switcher = (alert: Alert<DomainPrebidModuleAlert>): AlertData | undefined => {
    switch (alert.name) {
      case 'enabled':
        return {
          color: theme.palette.warning.main,
          Icon: (
            <SvgIcon
              component={UnpluggedIcon}
              inheritViewBox
            />
          ),
          tooltip: { text: alert.description },
        }

      default:
        throw Error('Missing alert config')
    }
  }

  return <Alerts<DomainPrebidModuleAlert> {...{ alerts, switcher }} />
}
